import React from 'react';

import * as S from './styled';

type Props = React.ComponentProps<'button'> & {
  size?: 'large' | 'middle',
  isBlink?: boolean,
  disabled?: boolean,
  checked?: boolean,
};

const Checkbox = ({
  size = '',
  isBlink = false,
  disabled = false,
  ...rest
}: Props): JSX.Element => (
  <S.Checkbox
    size={size}
    isBlink={isBlink}
    disabled={disabled}
  >
    <S.Input
      {...rest}
      size={size}
      type="checkbox"
      disabled={disabled}
    />
    <span />
  </S.Checkbox>
);

export default Checkbox;
